export enum PermitActions {
  REORDER = 'REORDER',
  CANCEL = 'CANCEL',
  COMPLETE_FORM = 'COMPLETE_FORM',
  PROCESS_WITH_JURISDICTION = 'PROCESS_WITH_JURISDICTION',
  MODIFY_STATE_APPLICATION = 'MODIFY_STATE_APPLICATION',
  AMEND = 'AMEND',
  MODIFY_WITH_JURISDICTION = 'MODIFY_WITH_JURISDICTION',
  COMPLETE_APPLICATION = 'COMPLETE_APPLICATION',
  KEEP_AS_IS = 'KEEP_AS_IS',
  REOPEN_FOR_CORRECTION = 'REOPEN_FOR_CORRECTION',
  VIEW = 'VIEW',
  REPLACE_TYPE = 'REPLACE_TYPE',
}
